/**
 * Split Content Image Selector Block
 * Handles image switching on accordion item hover/interaction
 */

class SplitContentImageSelector {
    constructor() {
        this.blocks = document.querySelectorAll('.split-content-image-selector');
        this.init();
    }

    init() {
        if (this.blocks.length === 0) return;

        this.blocks.forEach(block => {
            this.setupBlock(block);
        });
    }

    setupBlock(block) {
        const accordionItems = block.querySelectorAll('.accordion_item');
        const imageWrappers = block.querySelectorAll('.accordion__image-wrapper');

        if (accordionItems.length === 0 || imageWrappers.length === 0) return;

        // Set first item as active by default
        this.setActiveItem(accordionItems[0], imageWrappers, 0);

        // Add event listeners for each accordion item
        accordionItems.forEach((item, index) => {
            // Mouse enter - change image
            item.addEventListener('mouseenter', () => {
                this.handleItemHover(item, imageWrappers, index, accordionItems);
            });

            // Click handling for links
            item.addEventListener('click', (e) => {
                this.handleItemClick(item, imageWrappers, index, accordionItems, e);
            });

            // Touch support for mobile
            item.addEventListener('touchstart', () => {
                this.handleItemHover(item, imageWrappers, index, accordionItems);
            }, { passive: true });
        });

        // Add keyboard accessibility
        this.addKeyboardSupport(accordionItems, imageWrappers);
    }

    handleItemHover(item, imageWrappers, index, accordionItems) {
        // Remove active state from all items
        accordionItems.forEach(accordionItem => {
            accordionItem.classList.remove('is-active');
        });

        // Add active state to current item
        item.classList.add('is-active');

        // Switch images
        this.switchImage(imageWrappers, index);
    }

    handleItemClick(item, imageWrappers, index, accordionItems, event) {
        // Set as active
        this.setActiveItem(item, imageWrappers, index);

        // If it's not a link, prevent default
        const link = item.querySelector('.accordion_item_link');
        if (!link) {
            event.preventDefault();
        }
    }

    setActiveItem(item, imageWrappers, index) {
        // Remove active from all accordion items
        const allItems = item.closest('.accordion_items').querySelectorAll('.accordion_item');
        allItems.forEach(accordionItem => {
            accordionItem.classList.remove('is-active');
        });

        // Set current as active
        item.classList.add('is-active');

        // Switch image
        this.switchImage(imageWrappers, index);
    }

    switchImage(imageWrappers, activeIndex) {
        // Hide all images
        imageWrappers.forEach((wrapper, index) => {
            wrapper.classList.remove('is-active');
            
            // Add a small delay for smooth transition
            if (index === activeIndex) {
                setTimeout(() => {
                    wrapper.classList.add('is-active');
                }, 50);
            }
        });
    }

    addKeyboardSupport(accordionItems, imageWrappers) {
        accordionItems.forEach((item, index) => {
            // Make items focusable
            if (!item.querySelector('.accordion_item_link')) {
                item.setAttribute('tabindex', '0');
            }

            // Add keyboard event listeners
            item.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.handleItemHover(item, imageWrappers, index, accordionItems);
                }

                // Arrow key navigation
                if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.handleArrowNavigation(e.key, accordionItems, imageWrappers, index);
                }
            });
        });
    }

    handleArrowNavigation(key, accordionItems, imageWrappers, currentIndex) {
        let newIndex;

        if (key === 'ArrowDown') {
            newIndex = currentIndex + 1 >= accordionItems.length ? 0 : currentIndex + 1;
        } else {
            newIndex = currentIndex - 1 < 0 ? accordionItems.length - 1 : currentIndex - 1;
        }

        // Focus and activate new item
        accordionItems[newIndex].focus();
        this.handleItemHover(accordionItems[newIndex], imageWrappers, newIndex, accordionItems);
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new SplitContentImageSelector();
});

// Also initialize on dynamic content load (if using AJAX)
document.addEventListener('contentLoaded', () => {
    new SplitContentImageSelector();
});

// Export for potential external use
window.SplitContentImageSelector = SplitContentImageSelector;
